import React, { useEffect } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { BigCta } from "components/big-cta";
import { Footer } from "components/footer";
import { NavBar } from "components/navbar";
import PricingComponent from "components/pricing_component/PricingComponent";
import {
   support,
   trackingTool,
   reporting,
   collaboration,
   campaigns,
} from "components/pricing_component/PricingData";
import useHelper from "helpers";
import { Meta } from "seo/meta";

export default function Pricing() {
   const { t } = useTranslation("common");
   const router = useRouter();
   const query = router.query;

   const { handleCta } = useHelper();
   const handleClick = () => {
      window.$crisp.push(["do", "chat:open"]);
   };

   useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      if (params.get("instance")) {
         // console.log(query.instance);
         window.open(`https://app.metricks.io/login?instance=${params.get("instance")}`, "_top");
      }
   }, []);

   return (
      <Meta title={t("seo-about-title")} description={t("seo-about-description")}>
         <NavBar />

         <section className="pricing-sass">
            <div className="pricing-sass_top">
               <span className="ball first"></span>
               <span className="ball second"></span>
               <h1>Flexible plans designed to help you scale.</h1>
               <p>
                  From starter to custom, find a plan that suits your affiliate marketing needs and
                  integrate all plans with the tools you use.
               </p>
               <span className="ball third"></span>
               <span className="ball fourth"></span>
            </div>
            <div className="starter">
               <div className="starter_wrapper">
                  <div className="starter_left">
                     <h1>Starter</h1>
                     <h2 className="included">
                        WHAT”S INCLUDED <span></span>
                     </h2>
                     <div className="starter_left_details">
                        <ul>
                           <li>
                              <span className="dot"></span>{" "}
                              <span className="text">Unlimited Affiliates </span>
                           </li>
                           <li>
                              <span className="dot"></span>{" "}
                              <span className="text"> Single Access Campaign (SAC)</span>{" "}
                           </li>
                           <li>
                              <span className="dot"></span>{" "}
                              <span className="text">Free Transactional Fees</span>{" "}
                           </li>
                           <li>
                              <span className="dot"></span>{" "}
                              <span className="text">In-App Messaging</span>{" "}
                           </li>
                           <li>
                              <span className="dot"></span>{" "}
                              <span className="text">Fraud Prevention and Control</span>{" "}
                           </li>
                           <li>
                              <span className="dot"></span>{" "}
                              <span className="text">Unlimited Active Campaigns</span>{" "}
                           </li>
                           <li>
                              <span className="dot"></span>{" "}
                              <span className="text">Custom Affiliate Onboarding</span>{" "}
                           </li>
                           <li>
                              {" "}
                              <a href="#moveToSupport" style={{ display: "flex" }}>
                                 <span className="link">See all the features </span>{" "}
                                 <ArrowForwardIcon />{" "}
                              </a>
                           </li>
                        </ul>
                     </div>
                  </div>
                  <div className="starter_right">
                     <h2>All the features you need to create and manage winning campaigns </h2>
                     <h3 className="bills">
                        $59 <span>/ Billed monthly</span>{" "}
                     </h3>
                     <button
                        className="starter_btn"
                        style={{ cursor: "pointer" }}
                        onClick={handleCta}
                     >
                        Start Now
                     </button>
                  </div>
               </div>
            </div>
            <div className="starter custom">
               <div className="starter_wrapper">
                  <div className="starter_left">
                     <h1>For Custom</h1>
                     <h2 className="included">
                        WHAT”S INCLUDED <span></span>
                     </h2>
                     <div className="starter_left_details">
                        <ul>
                           <li>
                              <span className="dot"></span>{" "}
                              <span className="text">Unlimited Affiliates </span>
                           </li>
                           <li>
                              <span className="dot"></span>{" "}
                              <span className="text"> Single Access Campaign (SAC)</span>{" "}
                           </li>
                           <li>
                              <span className="dot"></span>{" "}
                              <span className="text">Free Transactional Fees</span>{" "}
                           </li>
                           <li>
                              <span className="dot"></span>{" "}
                              <span className="text">In-App Messaging</span>{" "}
                           </li>
                           <li>
                              <span className="dot"></span>{" "}
                              <span className="text">Fraud Prevention and Control</span>{" "}
                           </li>
                           <li>
                              <span className="dot"></span>{" "}
                              <span className="text">Unlimited Active Campaigns</span>{" "}
                           </li>
                           <li>
                              <span className="dot"></span>{" "}
                              <span className="text">Custom Affiliate Onboarding</span>{" "}
                           </li>
                           <li>
                              {" "}
                              <span className="link"> </span>{" "}
                           </li>
                        </ul>
                     </div>
                  </div>
                  <div className="starter_right">
                     <h2>Let's build you the a unique plan with all the features you love. </h2>
                     <h3 className="bills">Let’s Talk</h3>
                     <button
                        className="starter_btn"
                        onClick={() => handleClick()}
                        style={{ cursor: "pointer" }}
                     >
                        Let's talk
                     </button>
                  </div>
               </div>
            </div>
            <div className="maximize_header">
               <h2>experience affiliate marketing and tracking like never before</h2>
               <h1>
                  Maximize your affiliate programs with <span className="primary">Metricks</span>
               </h1>
               <div className="maximize_header_feature" id="moveToSupport">
                  <p>Features</p>
                  <p>starter</p>
               </div>
            </div>
            <PricingComponent data={support} value="5.531rem" />
            <PricingComponent data={trackingTool} value="5.531rem" />
            <PricingComponent data={reporting} value="5.531rem" />
            <PricingComponent data={collaboration} value="12.126rem" />
            <PricingComponent data={campaigns} value="11.968rem" />
         </section>
         <BigCta />
         <Footer />
      </Meta>
   );
}

export async function getStaticProps({ locale }) {
   return {
      props: {
         ...(await serverSideTranslations(locale, ["common", "footer"])),
         // Will be passed to the page component as props
      },
   };
}
